export const PdfExportIcon = () => {
    return (
        <svg
            fill="#000000"
            viewBox="0 0 24 24"
            id="print-alt"
            xmlns="http://www.w3.org/2000/svg"
            className={'h-7 w-7'}
        >
            <path
                id="secondary"
                d="M17,7H7V4A1,1,0,0,1,8,3h8a1,1,0,0,1,1,1ZM7,11v9a1,1,0,0,0,1,1h6l3-3V11Z"
                style={{
                    fill: 'rgb(44, 169, 188)',
                    strokeWidth: 2,
                }}
            ></path>
            <polyline
                id="primary"
                points="17 15 21 15 21 7 3 7 3 15 7 15"
                style={{
                    fill: 'none',
                    stroke: 'rgb(0, 0, 0)',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: 2,
                }}
            ></polyline>
            <path
                id="primary-2"
                data-name="primary"
                d="M17,7H7V4A1,1,0,0,1,8,3h8a1,1,0,0,1,1,1ZM7,11v9a1,1,0,0,0,1,1h6l3-3V11Z"
                style={{
                    fill: 'none',
                    stroke: 'rgb(0, 0, 0)',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: 2,
                }}
            ></path>
        </svg>
    );
};
